import { Flex } from 'deepstash-ui';
import useCollection from 'providers/hooks/useCollection';
import React from 'react';
import { GAP_SIZE_REM, SECTION_GAP_REM } from 'utils/global';
import CollectionSourceCard from './CollectionSourceCard';

const CollectionContainer: React.FC = () => {
  const { collection } = useCollection();

  if (!collection) return null;

  return (
    <Flex
      flexDir="column"
      w="100%"
      position="relative"
      gridGap={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
      py={{ base: GAP_SIZE_REM, md: SECTION_GAP_REM }}
    >
      {collection.sources.map((source, index) => {
        return (
          <CollectionSourceCard
            key={`collection-source-card-${index}`}
            source={source}
            zIndex={collection.sources.length - index}
          />
        );
      })}
    </Flex>
  );
};

export default CollectionContainer;
